import { useContext } from 'react';

import { StoreConnectContext } from 'context/StoreConnectContext';

export default function useStoreConnect() {
  const context = useContext(StoreConnectContext);

  if (!context) {
    throw new Error(
      'useStoreConnect must be used within a StoreConnectProvider'
    );
  }

  return context;
}
